import React from 'react';
export function SoilBand() {
  return <div aria-hidden="true" data-id="element-281" data-mp="3usea9xirx2rn">
      <div className="h-1.5 w-full bg-gold" data-id="element-282" data-mp="3uq0ko46v4irh" />
      <div className="h-1 w-full bg-earth" data-id="element-283" data-mp="2df1ic8umldtw" />
    </div>;
}